module.exports = __webpack_public_path__ + "img/progress.bae87ad7.svg";